<template>
	<div class="home">
		<!--topbar-->
		<div id="commonTopbar" class="commonTopbar" ref="topbar"></div>

		<!-- page -->
		<div class="page">
			<!-- 静态头图 -->
			<div class="static-img">
				<img :src="staticImg" alt="" />
			</div>
			<!-- 轮播图 -->
			<div class="swiper">
				<swiper
					ref="mySwiper"
					:options="swiperOption"
					v-if="swiperImg.length > 0"
				>
					<swiper-slide
						class="swiper-slide"
						v-for="item in swiperImg"
						:key="item.cardPicUrl"
					>
						<img :src="item.cardPicUrl" alt="" />
					</swiper-slide>

					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<!-- 职位列表 -->
			<JobList
				:subListData="subListData"
				:jobListData="jobListData"
				:pid="pid"
				:lastPage="lastPage"
				:city="city"
				@getData="getData"
			/>
		</div>
	</div>
</template>

<script>
import { reactive, ref, onMounted, nextTick } from '@vue/composition-api';
import JobList from '@/components/JobList/index.vue';
import { getJobList } from '@/api/index';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
	name: 'Home',
	components: { swiperSlide, swiper, JobList },
	mounted() {},
	setup() {
		const city = ref('北京'); //城市
		const staticImg = ref(''); // 静态头图
		const swiperImg = ref([]); // 轮播图

		const subListData = ref([]); // 行业标签数据
		const jobListData = ref([]); // 职位列表数据
		const lastPage = ref(false);
		const pid = ref('');

		const swiperOption = reactive({
			loop: true,
			speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
			slidesPerView: 1, //数量
			direction: 'horizontal', //设置水平还是垂直vertical
			pagination: {
				el: '.swiper-pagination', //与slot="pagination"处 class 一致
				clickable: true //轮播按钮支持点击
			},
			autoplay: {
				delay: 2000 //自动切换的时间间隔，单位ms
			}
		});

		const getData = async (p, changeMark) => {
			const params = p
				? p
				: {
						page: '1',
						pageSize: '50',
						pageType: 'zpchihewanle',
						pid: '',
						dispcateid: '',
						type: 'getHeadImage,getSlideImage,getTradeTab,getInfoList'
				  };
			const {
				code,
				header,
				silderBanner,
				subList,
				jobList,
				traceLog,
				cityName
			} = await getJobList(params);

			if (code === '0') {
				if (!p) {
					staticImg.value = header && header.backgroundpic;
					swiperImg.value = silderBanner;
					subListData.value = subList;
				}
				city.value = cityName;
				jobListData.value = changeMark
					? jobList.data
					: jobListData.value.concat(jobList.data);
				lastPage.value = jobList.lastPage;
				pid.value = traceLog.pid;

				await nextTick();
				const e = document.getElementsByClassName('bar_left')[0];
				if (e.childNodes[0]) {
					e.childNodes[0].innerHTML = cityName;
					e.childNodes[0].style.visibility = 'visible';
				}
			} else {
				throw new Error('职位列表数据请求失败');
			}
		};

		onMounted(() => {
			window.CL.invoke('topbar', {
				changeCity: false, // 切换城市
				aroundCity: false, // 周围城市
				weather: false,
				appQR: true, // homepage QR
				homepageLink: true
			});
			getData();
		});

		return {
			swiperOption,
			staticImg,
			swiperImg,
			jobListData,
			subListData,
			lastPage,
			pid,
			city,
			getData
		};
	}
};
</script>

<style lang="scss">
img[src=''],
img:not([src]) {
	opacity: 0;
}

.commonTopbar .bar_left h2 {
	visibility: hidden;
}

.home {
	.page {
		.static-img {
			width: 100%;
			height: 10vw;
			// background-color: #fa7d6d;
			border: none;
			img {
				width: 100%;
				height: 10vw;
				object-fit: cover;
			}
		}
		.swiper {
			width: 100%;
			height: 21vw;
			// background-color: #fa7d6d;
			.swiper-slide {
				img {
					width: 100%;
					height: 21vw;
					object-fit: cover;
				}
			}

			.swiper-pagination {
				.swiper-pagination-bullet-active {
					background-color: #f29b76;
				}
			}
		}
	}
}
</style>
